// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import React, { useContext } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core";

import { CustomerContext } from "components/App/DashboardApp";
import TestRunProgressBar from "./TestRunProgressBar";
import { cx } from "style/utils";

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    headerRoot: {
      marginBottom: "1rem",
    },
  })
);

export default () => {
  const classes = useStyle();
  const customContext = useContext(CustomerContext);

  return (
    <>
      {customContext?.showProgressBar && (
        <div className={cx(["container", classes.headerRoot])}>
          <TestRunProgressBar />
        </div>
      )}
    </>
  );
};
